import update from 'immutability-helper';
import { REMOTE_CONFIG_DEFAULT, REMOTE_CONFIG_KEYS } from '../../constants';
import { createReducer } from '../../utils/redux/reducers.utils';
import { GENERAL_CONFIG_UPDATE } from '../actions';

const initialState = REMOTE_CONFIG_DEFAULT[REMOTE_CONFIG_KEYS.GENERAL_CONFIG];

const updateGeneralConfigStatus = (state, payload) =>
  update(state, {
    $merge: payload,
  });

const actionsRepo = {
  [GENERAL_CONFIG_UPDATE]: updateGeneralConfigStatus,
};

export default createReducer({ initialState, actionsRepo });
